<template>
  <div class="nfc-touch-view" v-if="inited">
    <div class="top-sticky">
      <div></div>
      <div class="link-title">{{ nfcData.linkData.drawer.name }}</div>
      <div>
        <router-link :to="{name: 'ClosetContentListAll'}">返回</router-link>
      </div>
    </div>

    <div class="bottom-content">
      <div class="container">
        <ClothCardList
          :cloths="cloths"
          :showTitle="false"
          @clothClicked="clothClicked"
        ></ClothCardList>
      </div>
    </div>

    <transition name="fade">
      <FullScreenModal v-if="showViewCloth" title="檢視單品" @back="closeViewClothModal">
        <ViewClothContent :cloth="selectedCloth"></ViewClothContent>
      </FullScreenModal>
    </transition>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import commonBusyAndErrorHandling from '../../assets/js/commonBusyAndErrorHandling';
  import ClothCardList from '../../components/clothList/ClothCardList.vue';
  import FullScreenModal from '@/components/FullScreenModal.vue';
  import ViewClothContent from '@/views/closet/ViewClothContent';

  export default {
    mixins: [commonBusyAndErrorHandling],
    name: 'NFCTouchView',
    data() {
      return {
        inited: false,
        nfcId: '',

        nfcData: {},
        showViewCloth: false,
        selectedCloth: {},
      };
    },
    components: {
      ClothCardList,
      FullScreenModal,
      ViewClothContent,
    },
    computed: {
      cloths() {
        return this.nfcData.linkData.cloths;
      }
    },
    props: {
    },
    mounted() {
      const id = this.$route.params.id;
      this.nfcId = id;

      this.handleAsyncTask(async() => {
        const data = await this.$store.dispatch('api/getNFCReadIdPromise', this.nfcId);
        this.nfcData = Object.assign({}, data);
        this.inited = true;
      });
    },
    methods: {
      ...mapActions(['showMsgModal', 'appendComponentBusy', 'clearComponentBusy', 'appendErrorMsg']),
      closeViewClothModal() {
        this.showViewCloth = false;
      },
      clothClicked(cloth) {
        this.selectedCloth = Object.assign({}, cloth);
        this.showViewCloth = true;
      },
    },
  }
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

.nfc-touch-view {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding-bottom: 4rem;
  @include bigger-than-large {
    max-width: 720px;
    margin: 0 auto;
  }
  .top-sticky {
    position: sticky;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    padding: .8rem .5rem;
    background-color: $color-border;
    border-bottom: solid 1px $color-border;
    z-index: 10;
    .link-title {
      font-size: 1.2em;
    }
  }

  .bottom-content {
    padding: 1rem 0;
  }
}
</style>